__turbopack_context__.v({
  "accordion": "ConnectAppsModal-module__E_txAq__accordion",
  "accordionHeader": "ConnectAppsModal-module__E_txAq__accordionHeader",
  "accordionHeaderLabel": "ConnectAppsModal-module__E_txAq__accordionHeaderLabel",
  "accordionList": "ConnectAppsModal-module__E_txAq__accordionList",
  "accordionTitle": "ConnectAppsModal-module__E_txAq__accordionTitle",
  "appBlock": "ConnectAppsModal-module__E_txAq__appBlock",
  "appName": "ConnectAppsModal-module__E_txAq__appName",
  "body": "ConnectAppsModal-module__E_txAq__body",
  "confirmActions": "ConnectAppsModal-module__E_txAq__confirmActions",
  "confirmPopover": "ConnectAppsModal-module__E_txAq__confirmPopover",
  "connectionName": "ConnectAppsModal-module__E_txAq__connectionName",
  "createdForYouPill": "ConnectAppsModal-module__E_txAq__createdForYouPill",
  "footerTrigger": "ConnectAppsModal-module__E_txAq__footerTrigger",
  "headerStack": "ConnectAppsModal-module__E_txAq__headerStack",
  "list": "ConnectAppsModal-module__E_txAq__list",
  "listItem": "ConnectAppsModal-module__E_txAq__listItem",
  "loading": "ConnectAppsModal-module__E_txAq__loading",
  "menuFooter": "ConnectAppsModal-module__E_txAq__menuFooter",
  "menuItem": "ConnectAppsModal-module__E_txAq__menuItem",
  "menuItemCheck": "ConnectAppsModal-module__E_txAq__menuItemCheck",
  "menuItemRow": "ConnectAppsModal-module__E_txAq__menuItemRow",
  "menuItemTitle": "ConnectAppsModal-module__E_txAq__menuItemTitle",
  "menuPanel": "ConnectAppsModal-module__E_txAq__menuPanel",
  "menuScroll": "ConnectAppsModal-module__E_txAq__menuScroll",
  "row": "ConnectAppsModal-module__E_txAq__row",
  "rowAction": "ConnectAppsModal-module__E_txAq__rowAction",
  "rowHeading": "ConnectAppsModal-module__E_txAq__rowHeading",
  "rowIcon": "ConnectAppsModal-module__E_txAq__rowIcon",
  "rowInfo": "ConnectAppsModal-module__E_txAq__rowInfo",
  "rowText": "ConnectAppsModal-module__E_txAq__rowText",
  "wiredState": "ConnectAppsModal-module__E_txAq__wiredState",
  "zapRow": "ConnectAppsModal-module__E_txAq__zapRow",
  "zapRowExternal": "ConnectAppsModal-module__E_txAq__zapRowExternal",
  "zapRowTitle": "ConnectAppsModal-module__E_txAq__zapRowTitle",
});
